// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card--3zf4E","Empty":"Empty--38BVr"};